import api from './api';

export const purgeLegacySharedStudyStorage = () => {
  try {
    localStorage.removeItem('sao_viet_quiz_state_v3');
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (
        k.startsWith('sao_viet_study_v3_') ||
        k.startsWith('sao_viet_study_v4_') ||
        k.startsWith('sao_viet_study_v5_guest_')
      ) {
        localStorage.removeItem(k);
      }
    }
  } catch (e) {
    // ignore
  }
};

export const loginUser = async (email, password) => {
  try {
    // API expects username and password in form format
    const params = new URLSearchParams();
    params.append('username', email);
    params.append('password', password);

    const response = await api.post('/auth/login', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const { access_token } = response.data;
    
    // Store token
    localStorage.setItem('token', access_token);
    purgeLegacySharedStudyStorage();
    
    // Get user info with the token
    const user = await getCurrentUser();
    
    return user;
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    const detail = error.response?.data?.detail;
    let errMsg = 'Đăng nhập không thành công. Vui lòng kiểm tra lại thông tin.';
    if (typeof detail === 'string') {
      errMsg = detail;
    } else if (detail && typeof detail === 'object') {
      errMsg = detail.message || detail.error || 'Tài khoản không đủ quyền hoặc đã hết hạn truy cập.';
    } else if (error.message) {
      errMsg = error.message;
    }
    throw new Error(errMsg);
  }
};

export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    
    // Get current user profile
    const response = await api.get('/users/me');
    const user = response.data;
    
    // Store user data
    localStorage.setItem('user', JSON.stringify(user));
    
    return user;
  } catch (error) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    throw error;
  }
};

export const logoutUser = async () => {
  // Clear local storage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  purgeLegacySharedStudyStorage();
  // No need for an API call since we're using JWT
  return true;
};

export const getStoredUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error parsing stored user:', error);
    return null;
  }
};
